import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FEED_KIND, NUMBERS, PRODUCT_TYPE_CONSTANT_NAME, SCREEN_NAME } from 'src/app/constants/app.constants';
import { DataStorageService } from 'src/app/dataservices/data-storage.service';
import { GetService } from 'src/app/dataservices/get.service';

import { PostApiService } from '../../../dataservices/post-api.service';
import { PostingService } from '../posting.service';
import { NewLanguageService } from '../../../dataservices/new-language/new-language.service';
import { Analytics } from 'analytics2.0';
import { DETAIL_ENTRY, EXIT } from 'analytics2.0/dist/core/constants/analytic.interface';
import { FunCollectionService } from 'src/app/common/common-functions/fun-collection.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-filter-topic',
  templateUrl: './filter-topic.component.html',
  styleUrls: ['./filter-topic.component.scss']
})
export class FilterTopicComponent implements OnInit, OnDestroy  {

  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();

  @Output() nextPostScreen = new EventEmitter();

  public topicList= [];

  @Input() callingFrom;

  public showColor = false;

  public err_msg = '';

  public loading_data_in_process = false;

  constructor( public getClinicalCaseSer: GetService,  public dss: DataStorageService, private postApiSer:  PostApiService, public fcs: FunCollectionService,  private postingService: PostingService,   public mls: NewLanguageService,   private analyticSdk: Analytics){}

  ngOnInit(): void {
    this.getTopicList();

    const entryData: DETAIL_ENTRY = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.POSTING,
      entity_code: '0',
      source: this.fcs.currentScreename ? this.fcs.currentScreename : localStorage.getItem('triggerSource'),
      current_screen_name: SCREEN_NAME.CONTENT_TOPIC,
      start_time: new Date().getTime()
    }
    this.analyticSdk.analyticService.DETAIL_ENTRY(entryData);
  }

  /**
   * Get topic list
   */
  getTopicList(): void {
    this.loading_data_in_process = true;
    this.subscriptions.add(this.getClinicalCaseSer.getTopicList(this.dss.posting_data.screen3.selected_community).subscribe(data => {  
      this.topicList = data?.data?.list;
      this.loading_data_in_process = false;
    }));
  }

  /**
   * back To Previous
   */
  backToPrevious(): void {
    this.nextPostScreen.emit(0);
  }

  /**
   * file Uploading Process
   */
  fileUploadingProcess(): void {
    this.postApiSer.setPostButtonStatus(true);
    this.nextPostScreen.emit(6.1);
    this.uploadFile();
  }

  /**
   * upload File
   */
  uploadFile(): void {
    this.dss.calling_from_community = NUMBERS.ZERO;
    if (this.dss.posting_data.feed_edit_mode.is_edit === NUMBERS.ONE) {
      this.uploadFileForEditFeedPost(); return;
    }
    if (this.dss.posting_data.screen1.feed_kind !== FEED_KIND.POLL) {
      this.dss.posting_data.screen1.feed_kind = FEED_KIND.POST;
    }
    this.postingService.uploadFile();
  }

  /**
   * upload File For Edit Feed Post
   */
  uploadFileForEditFeedPost(): void {
    this.postingService.uploadFileForEditFeedPost();
  }

  addTopic(e): void {
    this.err_msg = '';
    this.dss.posting_data.screen5.selected_topic = [];
    if (e.target.checked == true) {
        this.dss.posting_data.screen5.selected_topic.push(e.target.value);
    }
    if (this.dss.posting_data.screen5.selected_topic.length) {
      this.showColor = true;
    } else {
      this.showColor = false;
    }
  }

  isSelectedTopic(topicId): boolean {
    if(this.dss.posting_data.screen5.selected_topic && this.dss.posting_data.screen5.selected_topic.length > 0){
      const codes = this.dss.posting_data.screen5.selected_topic.map(item => item.code)
      if(codes.includes(topicId) === true){
        this.showColor = true;
        return true;
      }
    }
  }

  /**
   * unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }

    const exitData: EXIT = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.POSTING,
      entity_code: '0',
      current_screen_name: SCREEN_NAME.CONTENT_FILTER,
      start_time: new Date().getTime(),
      end_time: new Date().getTime()
    }
    this.analyticSdk.analyticService.DETAIL_EXIT(exitData);
  }

}
